module.exports = __webpack_public_path__ + "static/img/2.d833b2ea.png";